import { Skeleton } from 'components/Skeleton/Skeleton'
import Styles from './Loading.module.scss'

export const Loading = ({ rows = 5 }: { rows?: number }) => (
  <Skeleton className={Styles.thinLine} active paragraph={{ rows }} title={false} />
)
